import { activityMtCo2e } from './experimentalEmissions';
import type { CanonicalEnergyActivityYear } from './types';
import type { ChartDisplayMode } from './elecNonresidentialChartSegments';

export interface ElecTotalChartSegments {
  residential: number;
  nonresidential: number;
  canonicalTotal: number;
  missingComponent: boolean;
}

function roundDisplay(n: number, mode: ChartDisplayMode): number {
  if (mode === 'emissions') return Math.round(n * 10) / 10;
  return Math.round(n);
}

function segmentFromKwh(value: number | null | undefined, mode: ChartDisplayMode): number | null {
  if (value == null || !Number.isFinite(value)) return null;
  if (mode === 'emissions') {
    const mt = activityMtCo2e(
      {
        value,
        unit: 'kWh',
        coverage: 'complete_observed',
        sourceClass: 'utility_observed',
        methodId: '',
        sourceNote: '',
        includedCategories: [],
        missingCategories: [],
      },
      'electricity'
    );
    return mt != null ? roundDisplay(mt, mode) : null;
  }
  return roundDisplay(value, mode);
}

export function buildElecTotalChartSegments(
  row: CanonicalEnergyActivityYear,
  mode: ChartDisplayMode
): ElecTotalChartSegments {
  const resSeg = segmentFromKwh(row.residential.value, mode);
  const nonresSeg = segmentFromKwh(row.nonresidential.value, mode);
  const missingComponent = resSeg == null || nonresSeg == null;
  const canonicalTotal = missingComponent ? Number.NaN : resSeg + nonresSeg;
  return {
    residential: resSeg ?? Number.NaN,
    nonresidential: nonresSeg ?? Number.NaN,
    canonicalTotal,
    missingComponent,
  };
}
